import {
  ASSET_CLASS_FORECAST_HORIZONS,
  type AssetClassForecastHorizon,
  resolvePdfTimeRange,
} from "@repo/shared/types";
import { Label } from "@/components/ui/label";
import { ToggleGroup, ToggleGroupItem } from "@/components/ui/toggle-group";
import { useT } from "@/lib/i18n/use-t";
import { T } from "./time-range-field.i18n";

type TimeRangeFieldProps = {
  id: string;
  /** Absent on a component saved before the setting existed: shown as 10Y. */
  value: AssetClassForecastHorizon | undefined;
  onChange: (value: AssetClassForecastHorizon) => void;
};

export function TimeRangeField({ id, value, onChange }: TimeRangeFieldProps) {
  const t = useT(T);

  return (
    <div className="space-y-2">
      <Label id={`${id}-label`}>{t.timeRange}</Label>
      <div>
        <ToggleGroup
          type="single"
          value={resolvePdfTimeRange(value)}
          // Radix reports "" when the pressed pill is pressed again; one range
          // is always selected, so that is ignored.
          onValueChange={(next) => {
            if (next) onChange(next as AssetClassForecastHorizon);
          }}
          className="justify-start"
          aria-labelledby={`${id}-label`}
        >
          {ASSET_CLASS_FORECAST_HORIZONS.map((h) => (
            <ToggleGroupItem key={h} value={h} className="px-3 text-xs" aria-label={t[`range${h}`]}>
              {h}
            </ToggleGroupItem>
          ))}
        </ToggleGroup>
      </div>
      <p className="text-xs text-muted-foreground">{t.timeRangeHelp}</p>
    </div>
  );
}
